import { LocalizedEnumify } from '@mews/framework';
import { Tag } from '@optimus-web/core';
import { getTagVariantFromTemporalTaskState } from '@mews-commander/utils';
import { TaskTemporalState } from './query';

const TaskStateTag = ({ temporalState }: { temporalState: TaskTemporalState }) => (
    <Tag variant={getTagVariantFromTemporalTaskState(temporalState)}>
        <LocalizedEnumify enumValue={temporalState} />
    </Tag>
);

export default TaskStateTag;
